import { Helmet } from 'react-helmet-async';
import HeroSection from '../components/HeroSection';
import ServicesOverview from '../components/ServicesOverview';
import FAQ from '../components/FAQ';
import PageMeta from '../components/PageMeta';
import { faqs } from '../data/faq';
import { BUSINESS } from '../data/business';

interface Props {
  onContactClick: () => void;
}

const HomePage = ({ onContactClick }: Props) => {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: BUSINESS.name,
    description: 'IT-Beratung für Privatpersonen – SmartHome, Netzwerk, WLAN, Hardware und 3D-Druck.',
    url: BUSINESS.url,
    telephone: BUSINESS.telephone,
    email: BUSINESS.email,
    address: BUSINESS.address,
    areaServed: 'DE',
    priceRange: '€',
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: f.a,
      },
    })),
  };

  return (
    <>
      <PageMeta
        title="IT-Beratung für Privatpersonen"
        description="Verständliche IT-Beratung für Zuhause: SmartHome, WLAN, Hardware-Kaufberatung und mehr – vor Ort in der Region oder per Telefon."
        path="/"
      />
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
        <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      </Helmet>
      <HeroSection onContactClick={onContactClick} />
      <ServicesOverview />
      <FAQ onContactClick={onContactClick} />
    </>
  );
};

export default HomePage;
